import "@nike/eds/dist/index.css";
import React, {useContext} from "react";
import {Route, Routes} from 'react-router-dom'
import {RequestDetail} from "./components/detail/RequestDetail";
import {RetriggerService} from "./components/shared/RetriggerService";
import {StructuredLogsService} from "./components/shared/StructuredLogsService";
import ApplicationSnackbar from "./components/shared/ApplicationSnackbar";
import SnackbarContext from "./providers/snackbar-context";
import {FlowSearchOverview} from "./components/search/FlowSearchOverview";
import StructuredLogContext from "./providers/structuredLog-context";
import DrsBulkCheckPage from "./components/drsbulkcheck/DrsBulkCheckPage";

const retriggerService: RetriggerService = new RetriggerService()
const structuredLogsService: StructuredLogsService = new StructuredLogsService()
interface AppProps {
    history?: any;
    permissions: any;
    locationTracker?: any;
}

function App({ locationTracker, history, permissions }: AppProps) {
    const snackbarCtx = useContext(SnackbarContext);
    return (
        <StructuredLogContext.Provider value={structuredLogsService}>
            <div>
                <Routes>
                    <Route path="/flow-overview" element={<FlowSearchOverview structuredLogsService={structuredLogsService} LocationTracker={locationTracker} permissions={permissions} />} />
                    <Route path="/flow-overview/details/:traceId" element={<RequestDetail structuredLogsService={structuredLogsService} retriggerService={retriggerService} LocationTracker={locationTracker} permissions={permissions} />} />
                    <Route path="/flow-overview/drs-bulk-checks" element={<DrsBulkCheckPage structuredLogsService={structuredLogsService} LocationTracker={locationTracker} permissions={permissions} />} />
                </Routes>
                {snackbarCtx.isDisplayed && <ApplicationSnackbar />}
            </div>
        </StructuredLogContext.Provider>
    );
}

export default App;
